import React from 'react'
import "./Whatweoffer.css"

import { FaLongArrowAltRight } from 'react-icons/fa'

import mma from "./fighting-img/mma.jpg"
import wrestling from "./fighting-img/wrestling.jpg"
import boxing from "./fighting-img/boxing.jpg"
import jiuJitsu from "./fighting-img/jiu-jitsu.jpg"
import judo from "./fighting-img/judo.jpg"
import kickBoxing from "./fighting-img/kick-boxing.jpg"
import taekwondo from "./fighting-img/taekwondo.jpg"
import muayThai from "./fighting-img/muay-thai.jpg"


const Card = ({ img, name, link }) => {
    return (
        <>
            <div className="wwo-card">
                <img src={img} alt="" />
                <div className="wwo-desc">
                    <p>{name}</p>
                    <a href={link} target='_blank' rel="noopener noreferrer" className='wwo-link'>
                        Read more <FaLongArrowAltRight className='wwo-arrow' />
                    </a>
                </div>
            </div>
        </>
    )

}

const Whatweoffer = () => {
    const fightingStyles = [
        {
            "id": 1,
            "photo": mma,
            "name": "mma",
            "link": "link",
        },
        {
            "id": 2,
            "photo": wrestling,
            "name": "Wrestling",
            "link": "link",
        },
        {
            "id": 3,
            "photo": boxing,
            "name": "boxing",
            "link": "link",
        },
        {
            "id": 4,
            "photo": judo,
            "name": "judo",
            "link": "link",
        },
        {
            "id": 5,
            "photo": taekwondo,
            "name": "taekwondo",
            "link": "link",
        },
        {
            "id": 6,
            "photo": kickBoxing,
            "name": "kick-boxing",
            "link": "link",
        },
        {
            "id": 7,
            "photo": jiuJitsu,
            "name": "jiu-jitsu",
            "link": "link",
        },
        {
            "id": 8,
            "photo": muayThai,
            "name": "muay-thai",
            "link": "link",
        },
    ];
    return (
        <div className="whatweoffer">
            <div className="wwo-header">
                <p className="our-speciality">Our Speciality</p>
                <p className='wwo-main-heading'>Get in the Best Shape</p>
                <p className="wwo-para">
                    At our academy, we offer a variety of combat sports and martial arts training, including MMA, boxing, Jiu-Jitsu, and "wrestling".
                    Our goal is to provide a comprehensive training experience that helps our students develop strength, endurance, technique, and discipline.
                    <br></br> <br></br>
                    Mixed Martial Arts (MMA) is a sport that combines various forms of fighting, including striking and grappling techniques, into a unified style.
                    Our MMA training program includes both stand-up and ground fighting techniques, preparing students to compete at any level.
                    <br></br> <br></br>
                    Our training programs are led by experienced coaches and instructors who create a supportive and challenging environment for students of all levels.
                    <br></br> <br></br>
                    Whether you are looking to compete professionally or just want to improve your fitness and self-defense skills, our academy offers something for everyone.
                </p>
            </div>
            <div className="wwo-cards">
                {
                    fightingStyles.map((item) => (
                        <Card
                            key={item.id}
                            img={item.photo}
                            name={item.name}
                            link={item.link}
                        />
                    ))
                }
            </div>
        </div>
    )
}
export default Whatweoffer